import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import DelugeFunction from "./DelugeFunction";
import AuthenticatedUser from "./AuthenticatedUser";
import InviteUser from "./InviteUser";
import {
  checkServiceAuth,
  getAllConnections,
  getServiceAuthUrl,
  revokeService,
} from "../../../../APICalling/UserInvitationApiCalling";
import {
  getOpenSnakErrorData,
  getOpenSnakSuccessData,
} from "../../../../config/otherConstant";
import { Loader } from "../../../atoms/Loader";
// import {
//   checkServiceAuth,
//   getServiceAuthUrl,
//   revokeService,
//   sendInvitalionLink,
// } from "../../../APICalling/ServiceAPICalling";
// import {
//   getOpenSnakErrorData,
//   getOpenSnakSuccessData,
// } from "../../../config/otherConstant";

const ZOHO = window?.ZOHO;

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function UserConnectionStatus({
  orgId,
  apiKey,
  dataCenterUrl,
  dataCenter,
  zApiKey,
  setSnack,
  service,
  allUsers,
  currentUser,
  reload,
  setReload,
}) {
  const [value, setValue] = React.useState(0);
  const [authenticatedUserLoading, setAuthenticatedUserLoading] =
    React.useState(true);
  const [authenticatedUsers, setAuthenticatedUsers] = React.useState([]);
  const [userAccess, setUserAccess] = React.useState();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  React.useEffect(() => {
    fetchConnection();
  }, [reload]);

  const fetchConnection = async () => {
    try {
      let headers = {
        orgId: orgId,
        apiKey: apiKey,
        dataCenterUrl: dataCenterUrl,
        dataCenter: dataCenter,
        connName: `${service?.serviceConnection}`,
        zApiKey: zApiKey,
        services: service?.services,
      };

      let authenticatedUserList = [];
      let tempUserAccess = {};
      const connectionList = await getAllConnections({ headers });
      connectionList?.forEach((connection) => {
        let userEmail = connection?.service_name?.substring(
          orgId?.length + service?.serviceConnection?.length + 4
        );
        authenticatedUserList.push(userEmail);
        tempUserAccess = {
          ...tempUserAccess,
          [userEmail]: connection?.scopeAccess,
        };
      });
      setAuthenticatedUsers((prev) => authenticatedUserList);
      setUserAccess((prev) => tempUserAccess);
      setAuthenticatedUserLoading((prev) => false);
    } catch (error) {}
  };

  const handleInvite = async (userEmail, scopes, scopeAccess) => {
    try {
      // https://www.zohoapis.com/crm/v2/functions/send_authentication_link/actions/execute?auth_type=oauth
      // Handle

      let serviceHeaders = {
        orgId: orgId,
        apiKey: apiKey,
        dataCenterUrl: dataCenterUrl,
        dataCenter: dataCenter,
        connName: `${service?.serviceConnection}__${userEmail}`,
        zApiKey: zApiKey,
        services: service?.services,
      };

      let serviceAuthUrl = await getServiceAuthUrl(serviceHeaders, {
        ...service,
        scopes: scopes,
        settingId: scopeAccess,
      });

      var func_name = "send_authentication_link";
      var req_data = {
        email: userEmail,
        url: serviceAuthUrl,
        service: service?.name,
        invitor: currentUser?.full_name,
        invitor_email: currentUser?.email,
      };

      ZOHO.CRM.FUNCTIONS.execute(func_name, req_data);
      setSnack(getOpenSnakSuccessData());
    } catch (error) {}
  };

  const handleRevokeUser = async (userEmail) => {
    try {
      let serviceHeaders = {
        orgId: orgId,
        apiKey: apiKey,
        dataCenterUrl: dataCenterUrl,
        dataCenter: dataCenter,
        connName: `${service?.serviceConnection}__${userEmail}`,
        zApiKey: zApiKey,
        services: service?.services,
      };
      const revokeUserResp = await revokeService(serviceHeaders, service);
      if (revokeUserResp) {
        setReload((prev) => !prev);

        setSnack(
          getOpenSnakSuccessData("Success! Connection revoked suffessfully.")
        );

        return;
      }

      setSnack(
        getOpenSnakErrorData(
          "Error! Couldn't revoke connection. Please try again"
        )
      );
    } catch (error) {}
  };

  const handleCheckUserAuthStatus = async (userEmail) => {
    try {
      let serviceHeaders = {
        orgId: orgId,
        apiKey: apiKey,
        dataCenterUrl: dataCenterUrl,
        dataCenter: dataCenter,
        connName: `${service?.serviceConnection}__${userEmail}`,
        zApiKey: zApiKey,
        services: service?.services,
      };

      const checkAuthResp = await checkServiceAuth(serviceHeaders);

      if (checkAuthResp) {
        setSnack(getOpenSnakSuccessData("Success!!! User is connected."));
        return;
      }
      setSnack(getOpenSnakErrorData("Error!!! User is not connected."));
      return;
    } catch (error) {}
  };

  if (authenticatedUserLoading) {
    return <Loader />;
  }

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Deluge Code" {...a11yProps(0)} />
          <Tab label="Authenticated User" {...a11yProps(1)} />
          <Tab label="Invite User" {...a11yProps(2)} />
        </Tabs>
      </Box>

      <DelugeFunction value={value} index={0} />
      <AuthenticatedUser
        value={value}
        index={1}
        authenticatedUsers={authenticatedUsers}
        activeUsers={[]}
        handleRevokeUser={handleRevokeUser}
        handleCheckUserAuthStatus={handleCheckUserAuthStatus}
        orgId={orgId}
        apiKey={apiKey}
        dataCenterUrl={dataCenterUrl}
        dataCenter={dataCenter}
        zApiKey={zApiKey}
        setSnack={setSnack}
        service={service}
        userAccess={userAccess}
        allUsers={allUsers}
        currentUser={currentUser}
      />

      <InviteUser
        value={value}
        index={2}
        authenticatedUsers={authenticatedUsers}
        activeUsers={[]}
        handleInvite={handleInvite}
        handleCheckUserAuthStatus={handleCheckUserAuthStatus}
        orgId={orgId}
        apiKey={apiKey}
        dataCenterUrl={dataCenterUrl}
        dataCenter={dataCenter}
        zApiKey={zApiKey}
        setSnack={setSnack}
        service={service}
        allUsers={allUsers}
        currentUser={currentUser}
      />

      {/* <InviteUser
        value={value}
        index={2}
        connectionDetails={connectionDetails}
        activeUsers={[]}
        handleInvite={handleInvite}
      /> */}
    </Box>
  );
}
/*
 */
